import { lazyLoad } from 'utils/loadable';

import { Navigate } from 'react-router-dom';

const HomePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'homePage', webpackPrefetch: true */ './HomePage'
  ),
);

// const LegislatorHomePage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'LegislatorHomePage', webpackPrefetch: true */ './LegislatorHome'
//   ),
// );

// const GovernmentHomePage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'GovernmentHomePage', webpackPrefetch: true */ './GovernmentHome'
//   ),
// );

// const BusinessHomePage = lazyLoad(() =>
//   import(
//     /*  webpackChunkName: 'BusinessHomePage', webpackPrefetch: true */ './BusinessHome'
//   ),
// );

const AboutPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'AboutPage', webpackPrefetch: true */ './AboutPage'
  ),
);

const ContactPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ContactPage', webpackPrefetch: true */ './ContactPage'
  ),
);

const PricingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'PricingPage', webpackPrefetch: true */ './Pricing/index'
  ),
);

const HelpPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'HelpPage', webpackPrefetch: true */ './HelpPage'
  ),
);

const TempHelpPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'HelpPage', webpackPrefetch: true */ './TempHelpPage'
  ),
);

const WhyCleandeskPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WhyCleandeskPage', webpackPrefetch: true */ './WhyCleandeskPage'
  ),
);

const ProductsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ProductsPage', webpackPrefetch: true */ './ProductsPage'
  ),
);

const SolutionPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SolutionPage', webpackPrefetch: true */ './SolutionPage'
  ),
);

const DevelopersPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'DevelopersPage', webpackPrefetch: true */ './DevelopersPage'
  ),
);

const ResourcesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ResourcesPage', webpackPrefetch: true */ './ResourcesPage'
  ),
);

const CraftPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CraftPage', webpackPrefetch: true */ './Products/Craft'
  ),
);

const SalesDemoPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'SalesDemoPage', webpackPrefetch: true */ './SalesDemoPage'
  ),
);

const DashboardDemoPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'DashboardDemoPage', webpackPrefetch: true */ './Demo/DashboardDemo'
  ),
);

const IspPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'IspPage', webpackPrefetch: true */ './Solutions/IspPage'
  ),
);

const EcomPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'EcomPage', webpackPrefetch: true */ './Solutions/EcomPage'
  ),
);

const WebsitePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WebsitePage', webpackPrefetch: true */ './Solutions/WebsitePage'
  ),
);

const WordpressPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WordpressPage', webpackPrefetch: true */ './Solutions/WordpressPage'
  ),
);

const InstagramPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'InstagramChannels', webpackPrefetch: true */ './Solutions/Channels/InstagramChannels'
  ),
);

const FacebookMessengerPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'FacebookMessengerChannels', webpackPrefetch: true */ './Solutions/Channels/FacebookMessengerChannels'
  ),
);

const WebWidgetPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WebWidgetChannels', webpackPrefetch: true */ './Solutions/Channels/WebWidgetChannels'
  ),
);

const WhatsappPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WhatsappChannels', webpackPrefetch: true */ './Solutions/Channels/WhatsappChannels'
  ),
);

const CapturePage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CapturePage', webpackPrefetch: true */ './Products/Capture'
  ),
);

const CarmaPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'Carma', webpackPrefetch: true */ './Products/Carma'
  ),
);

const SelfiPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'Selfi', webpackPrefetch: true */ './Products/Selfi'
  ),
);

const MagicsPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'MagicsPage', webpackPrefetch: true */ './Products/Magics'
  ),
);

const StarPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'StarPage', webpackPrefetch: true */ './Products/Star'
  ),
);

const CustomerSupportPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CustomerSupport', webpackPrefetch: true */ './UseCases/CustomerSupport'
  ),
);

const MarketingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'Marketing', webpackPrefetch: true */ './UseCases/Marketing'
  ),
);

const LeadGenerationPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'LeadGenerations', webpackPrefetch: true */ './UseCases/LeadGenerations'
  ),
);

const SalesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'Sales', webpackPrefetch: true */ './UseCases/Sales'
  ),
);

const EmployeeSupportPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'EmployeeSupport', webpackPrefetch: true */ './UseCases/EmployeeSupport'
  ),
);

const FeaturesPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'FeaturesPage', webpackPrefetch: true */ './Features/FeaturesPage'
  ),
);

const ChatSiteDemoPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ChatSiteDemoPage', webpackPrefetch: true */ './DemoUi/components/ChatSiteDemo'
  ),
);

const ChatBoxDemoPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'ChatSiteDemoPage', webpackPrefetch: true */ './DemoUi/components/ChatBoxDemo'
  ),
);

const MobileChatDemoPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'MobileChatDemoPage', webpackPrefetch: true */ './DemoUi/components/MobileChatDemo'
  ),
);

const InstagramDemoPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'InstagramDemo', webpackPrefetch: true */ './DemoUi/components/InstagramDemo'
  ),
);

const WhatsappDemoPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WhatsappDemo', webpackPrefetch: true */ './DemoUi/components/WhatsappDemo'
  ),
);

const FacebookDemoPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'FacebookDemo', webpackPrefetch: true */ './DemoUi/components/FacebookDemo'
  ),
);

const PartnersPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'FacebookDemo', webpackPrefetch: true */ './Partners/Partner'
  ),
);

const CaseStudyListingPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CaseStudyListingPage', webpackPrefetch: true */ './CaseStudy/index'
  ),
);

const CaseStudyPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'CaseStudyPage', webpackPrefetch: true */ './CaseStudy/components/CaseStudyPage'
  ),
);

export const AppHomeRoutes = {
  legislatorHome: '/legislator-home',
  governmentHome: '/government-home',
  businessHome: '/business-home',
};

export const ProductsSubMenuRoutes = {
  CAPTURE: '/products/capture',
  CARMA: '/products/carma',
  SELFI: '/products/selfi',
  MAGICS: '/products/magics',
  STAR: '/products/star',
  CRAFT: '/products/craft',
};

export const ChannelsSubMenuRoutes = {
  INSTAGRAM: '/solutions/channels/instagram',
  FACEBOOK_MESSENGER: '/solutions/channels/facebook-messenger',
  WHATSAPP_BUSINESS_API: '/solutions/channels/whatsapp-business-api',
  WEB_WIDGET: '/solutions/channels/web-widget',
};

export const useCasesSubMenuRoutes = {
  CUSTOMER_SUPPORT: '/use-cases/customer-support',
  EMPLOYEE_SUPPORT: '/use-cases/employee-support',
  SALES: '/use-cases/sales',
  LEAD_GENERATION: '/use-cases/lead-generation',
  MARKETING: '/use-cases/marketing',
};

// routes declaration
export const homeRoutes = [
  {
    component: HomePage,
    title: 'Home',
    path: '/',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: Navigate,
    path: '/',

    replace: true,
    to: '/dashboard/support',
    needsAuth: true,
    showForClientDomain: true,
  },
  // {
  //   component: LegislatorHomePage,
  //   title: 'Legislator',
  //   path: AppHomeRoutes.legislatorHome,
  //   allowedAfterLogin: true,
  // },
  // {
  //   component: GovernmentHomePage,
  //   title: 'Government',
  //   path: AppHomeRoutes.governmentHome,
  //   allowedAfterLogin: true,
  // },
  // {
  //   component: BusinessHomePage,
  //   title: 'Business',
  //   path: AppHomeRoutes.businessHome,
  //   allowedAfterLogin: true,
  // },
  {
    component: AboutPage,
    title: 'About',
    path: '/about-us',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: ContactPage,
    title: 'Callback',
    path: '/contact-us',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: PricingPage,
    title: 'Pricing',
    path: '/pricing',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: FeaturesPage,
    title: 'Features',
    path: '/features',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: TempHelpPage,
    title: 'Help',
    path: '/help',
    allowedAfterLogin: true,
    disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: WhyCleandeskPage,
    title: 'Why Cleandesk AI',
    path: '/why-cleandesk-ai',
    allowedAfterLogin: true,
    disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: ProductsPage,
    title: 'Products',
    path: '/products',
    allowedAfterLogin: true,
    disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: CapturePage,
    title: 'Capture',
    path: ProductsSubMenuRoutes.CAPTURE,
    allowedAfterLogin: true,
    disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: CarmaPage,
    title: 'Carma',
    path: ProductsSubMenuRoutes.CARMA,
    allowedAfterLogin: true,
    // disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: SelfiPage,
    title: 'Selfi',
    path: ProductsSubMenuRoutes.SELFI,
    allowedAfterLogin: true,
    // disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: MagicsPage,
    title: 'Magics',
    path: ProductsSubMenuRoutes.MAGICS,
    allowedAfterLogin: true,
    // disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: StarPage,
    title: 'Star',
    path: ProductsSubMenuRoutes.STAR,
    allowedAfterLogin: true,
    disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: SolutionPage,
    title: 'Solutions',
    path: '/solutions',
    allowedAfterLogin: true,
    disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: DevelopersPage,
    title: 'Developers',
    path: '/developers',
    allowedAfterLogin: true,
    disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: ResourcesPage,
    title: 'Resources',
    path: '/resources',
    allowedAfterLogin: true,
    disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: CraftPage,
    title: 'Craft',
    path: ProductsSubMenuRoutes.CRAFT,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: IspPage,
    title: 'ISP',
    path: '/solutions/isp',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: EcomPage,
    title: 'Ecommerce',
    path: '/solutions/ecommerce',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: WebsitePage,
    title: 'Ecommerce',
    path: '/solutions/websites',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: WordpressPage,
    title: 'Wordpress',
    path: '/solutions/wordpress',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: InstagramPage,
    title: 'Instagram',
    path: ChannelsSubMenuRoutes.INSTAGRAM,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: FacebookMessengerPage,
    title: 'Facebook Messenger',
    path: ChannelsSubMenuRoutes.FACEBOOK_MESSENGER,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: WebWidgetPage,
    title: 'Web Widget',
    path: ChannelsSubMenuRoutes.WEB_WIDGET,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: WhatsappPage,
    title: 'WhatsApp Business API',
    path: ChannelsSubMenuRoutes.WHATSAPP_BUSINESS_API,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: PartnersPage,
    title: 'Partner',
    path: '/partners',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: CaseStudyListingPage,
    title: 'Case Studies',
    path: '/case-studies',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: CaseStudyPage,
    title: 'Case Study',
    path: '/case-study',
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: CustomerSupportPage,
    title: 'Customer Support',
    path: useCasesSubMenuRoutes.CUSTOMER_SUPPORT,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: SalesPage,
    title: 'Sales',
    path: useCasesSubMenuRoutes.SALES,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: MarketingPage,
    title: 'Marketing',
    path: useCasesSubMenuRoutes.MARKETING,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: LeadGenerationPage,
    title: 'Customer Support',
    path: useCasesSubMenuRoutes.LEAD_GENERATION,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: EmployeeSupportPage,
    title: 'Employee Support',
    path: useCasesSubMenuRoutes.EMPLOYEE_SUPPORT,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: SalesDemoPage,
    title: 'Sales Demo',
    path: '/sales-demo',
    hidePublicNavbar: true,
    hideCustomFooter: true,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: DashboardDemoPage,
    title: 'Dashboard Demo',
    path: '/dashboard-demo',
    hidePublicNavbar: true,
    hideCustomFooter: true,
    allowedAfterLogin: true,
    hideForClientDomain: true,
  },
  {
    component: HelpPage,
    title: 'Help',
    path: '/help-guide/:helpFor',
    allowedAfterLogin: true,
    disableFullScroll: true,
    hideForClientDomain: true,
  },
  {
    component: ChatSiteDemoPage,
    title: 'Chat Site Demo',
    path: '/demo/chat-site',
    allowedAfterLogin: true,
    hideForClientDomain: true,
    hideChatWidget: true,
  },
  {
    component: ChatBoxDemoPage,
    title: 'Chat Box Demo',
    path: '/demo/chat-box',
    allowedAfterLogin: true,
    hideForClientDomain: true,
    hideChatWidget: true,
  },
  {
    component: MobileChatDemoPage,
    title: 'Mobile Chat Demo',
    path: '/demo/mobile-view',
    allowedAfterLogin: true,
    hideForClientDomain: true,
    hideChatWidget: true,
  },
  {
    component: InstagramDemoPage,
    title: 'Instagram Demo',
    path: '/demo/instagram',
    allowedAfterLogin: true,
    hideForClientDomain: true,
    hideChatWidget: true,
  },
  {
    component: WhatsappDemoPage,
    title: 'Whatsapp Demo',
    path: '/demo/whatsapp',
    allowedAfterLogin: true,
    hideForClientDomain: true,
    hideChatWidget: true,
  },
  {
    component: FacebookDemoPage,
    title: 'Facebook Demo',
    path: '/demo/facebook',
    allowedAfterLogin: true,
    hideForClientDomain: true,
    hideChatWidget: true,
  },
];
